import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';
import { UserRolesEnum } from 'src/app/common/enums/user-roles-enum';
import { UserManageService } from 'src/app/services/user-manage.service';

@Component({
    selector: 'app-delete-user-dialog',
    templateUrl: './delete-user-dialog.component.html',
    styleUrls: ['./delete-user-dialog.component.css'],
    standalone: false
})
export class DeleteUserDialogComponent implements OnInit {

  currentUser=this.userManageService.currentUser
  currentClinic=this.userManageService.currentClinic
  currentOffice=this.userManageService.currentOffice

  UserRolesEnum=UserRolesEnum

  constructor(private dialogRef: MatDialogRef<any>,private userManageService:UserManageService) { }

  ngOnInit(): void {
    this.dialogRef.afterClosed().pipe(take(1)).subscribe(() =>
      {
        
          this.userManageService.clearUser()
        
      })
  }


  exit()
  {
    this.userManageService.clearUser()
    this.dialogRef.close(`Excellent`);
  }

  onSubmit()
  {

    this.userManageService.deleteUser()
    this.dialogRef.close(`Excellent`);
    
  }
}
